import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import  { PRODUCT_API, POPULAR_API, ALL_PRODUCTS_API , FAVORITES_API,IMAGE_BASE_URL } from "./apiurls";
import { NavLink } from "react-router-dom"; 
//  NavLink not used currently, kept as requested
import { useNavigate } from "react-router-dom";
// navigate not used currently, kept as requested

import {
  addItemToCart,
  changeItemAmount,
  deleteItemFromCart,
  setCategoryProducts 
} from "../redux/winesSlice";

import "./WineItem.css";

/* ================= STAR RATING ================= */

const StarRating = ({ raiting, max = 5 }) => {
  const percentage = Math.min((raiting / max) * 100, 100);

  return (
    <div className="star-rating">
      <div className="stars-outer">
        ★★★★★
        <div className="stars-inner" style={{ width: `${percentage}%` }}>
          ★★★★★
        </div>
      </div>
      <span className="rating-text">
        {raiting.toFixed(1)}/{max}
      </span>
    </div>
  );
};

/* ================= MAIN COMPONENT ================= */

function WineItem({
  cat_id,
  allCategories = [],
  selectedShop,
  selectedShops = [],
  mlFilter,
  nearbyShops,
  searchKeyword,
  isFavoritesPage = false,
  favoriteIds = [],
  favorites = [],
  setFavorites,
  setFavoriteIds
}) {

  
  // ❌ These states are NOT needed for list rendering
  // ❌ Kept only because you asked not to remove anything
  const [itemAmount, setItemAmount] = useState(0);
  const [currentPrice, setCurrentPrice] = useState(null);
const [showLoginMessage, setLoginMessage]=useState(false);
const isLoggedIn=localStorage.getItem("isLoggedIn")==="true";

  const [loading, setLoading] = useState(false);
const [selectedProduct, setSelectedProduct] = useState(null);

  const itemsInCart = useSelector(state => state.wines.cart);
  const productsByCategory = useSelector(
  state => state.wines.productsByCategory
);

console.log("========== PRODUCT DATA DEBUG ==========");
console.log("Current cat_id:", cat_id);
console.log("Current cat_id type:", typeof cat_id);
console.log("productsByCategory:", productsByCategory);
console.log(
  "productsByCategory[current cat_id]:",
  productsByCategory[String(cat_id)]
);

const productData = isFavoritesPage
  ? favorites
  : searchKeyword?.trim()
  ? productsByCategory["ALL"] || []
  : productsByCategory[String(cat_id)] || [];
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ❗ not used, kept as requested
const showStockLimit = () => {
    alert("No more items available");
  };
{/*const toggleFavorite = async (id, bm_id) => {
  try {
    const userMobile = localStorage.getItem("userMobile");

    const response = await fetch(
      FAVORITES_API,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          action: "add",
          user_mobile: userMobile,
          bm_id: bm_id
        })
      }
    );

    const data = await response.json();

    // Print API response in console
    console.log("ADD Favorite Response:", data);

    // Keep your existing local toggle logic
    setFavorites(prev =>
      prev.includes(id)
        ? prev.filter(f => f !== id)
        : [...prev, id]
    );

  } catch (error) {
    console.error("Add Favorite Error:", error);
  }
};*/}
 
  useEffect(() => {
    // ❌ item DOES NOT EXIST
    // ❌ shared state cannot work for mapped lists

    /*
    const cartItem = itemsInCart.find(v => v.item.id === item.id);

    if (cartItem) {
      setItemAmount(cartItem.amount);
      setCurrentPrice(cartItem.amount * item.price);
    } else {
      setItemAmount(0);
      setCurrentPrice(null);
    }
    */
  }, [itemsInCart]);

  /* ================= FETCH PRODUCTS ================= */
useEffect(() => {
  if (!cat_id && !searchKeyword) return;

  async function fetchProductDetails() {
    setLoading(true);

    try {
      console.log("========== CATEGORY DEBUG START ==========");
      console.log("cat_id:", cat_id);
      console.log("cat_id type:", typeof cat_id);
      console.log("searchKeyword:", searchKeyword);
      console.log("productsByCategory BEFORE FETCH:", productsByCategory);

      /* ================= ALL ================= */

      if (cat_id === "ALL") {

        if (!allCategories || allCategories.length === 0) {
          setLoading(false);
          return;
        }

        console.log("CATEGORY MODE: ALL");
        console.log("allCategories:", allCategories);
        console.log("allCategories count:", allCategories.length);

        const results = await Promise.all(
          allCategories.map(async (cat) => {

            if (productsByCategory[String(cat.cat_id)]) {
              return productsByCategory[String(cat.cat_id)];
            }

            const res = await fetch(
              PRODUCT_API.replace("${cat_id}", cat.cat_id)
            );

            const text = await res.text();

            if (text.includes("no record")) {
              return [];
            }

            try {
              return JSON.parse(text);
            } catch {
              return [];
            }

          })
        );

        const products = results
          .flat()
          .filter(p => p && p.bm_id);

        const formatted = products.map(p => ({
          ...p,
          id: String(p.bm_id)
        }));

        console.log("ALL PRODUCTS AFTER FETCH:", products);
        console.log("ALL PRODUCTS COUNT:", products.length);
        console.log("ALL FORMATTED PRODUCTS:", formatted);

        dispatch(
          setCategoryProducts({
            cat_id: "ALL",
            products: formatted
          })
        );
      }

      /* ================= POPULAR ================= */

      else if (cat_id === "POPULAR") {

        const res = await fetch(POPULAR_API);

        const data = await res.json();

        const formatted = data.map(p => ({
          ...p,
          id: String(p.bm_id)
        }));

        dispatch(
          setCategoryProducts({
            cat_id: "POPULAR",
            products: formatted
          })
        );
      }

      /* ================= SINGLE CATEGORY ================= */

else {

  console.log("========== SINGLE CATEGORY DEBUG ==========");
  console.log("Selected category ID:", cat_id);
  console.log("Selected category ID type:", typeof cat_id);

  const categoryKey = String(cat_id);

  console.log("Redux lookup key:", categoryKey);
  console.log(
    "Already in productsByCategory:",
    productsByCategory[categoryKey]
  );

  if (productsByCategory[categoryKey]) {

    console.log(
      "CATEGORY ALREADY EXISTS IN REDUX:",
      productsByCategory[categoryKey]
    );

    setLoading(false);
    return;
  }

  const apiUrl = PRODUCT_API.replace("${cat_id}", cat_id);

  console.log("CATEGORY API URL:", apiUrl);

  const res = await fetch(apiUrl);

  console.log("CATEGORY API STATUS:", res.status);
  console.log("CATEGORY API OK:", res.ok);

        const text = await res.text();

        console.log("CATEGORY API RAW RESPONSE:", text);

        if (text.includes("no record")) {

          dispatch(
            setCategoryProducts({
              cat_id: String(cat_id),
              products: []
            })
          );

          return;
        }

        const data = JSON.parse(text);

console.log("CATEGORY API PARSED DATA:", data);
console.log("CATEGORY API PRODUCT COUNT:", data.length);

const formatted = data.map(p => ({
  ...p,
  id: String(p.bm_id)
}));

console.log("CATEGORY FORMATTED DATA:", formatted);
console.log("CATEGORY FORMATTED COUNT:", formatted.length);

console.log("========== SAVING CATEGORY PRODUCTS ==========");
console.log("Saving category ID:", String(cat_id));
console.log("Saving product count:", formatted.length);
console.log("Saving products:", formatted);

        dispatch(
          setCategoryProducts({
            cat_id: String(cat_id),
            products: formatted
          })
        );
      }

      /* ================= ALL PRODUCTS FOR SEARCH ================= */

      if (
        searchKeyword &&
        !productsByCategory["ALL"]
      ) {

        const res = await fetch(ALL_PRODUCTS_API);

        const data = await res.json();

        const formattedAll = data.map(p => ({
          ...p,
          id: String(p.bm_id)
        }));

        dispatch(
          setCategoryProducts({
            cat_id: "ALL",
            products: formattedAll
          })
        );
      }

    } catch (err) {

      console.error("Product fetch error:", err);

    } finally {

      setLoading(false);

    }
  }

  fetchProductDetails();

}, [
  cat_id,
  allCategories,
  dispatch,
  isFavoritesPage,
  searchKeyword
]);
{/*useEffect(() => {
  const savedFavs = localStorage.getItem("wineFavorites");
  if (savedFavs) {
    setFavorites(JSON.parse(savedFavs));
  }
}, []);
useEffect(() => {
  localStorage.setItem("wineFavorites", JSON.stringify(favorites));
}, [favorites]);*/}
const deleteFavorite=async (bm_id)=>{
  const favoriteRecord=favorites.find(
    f=> String(f.bm_id)===String(bm_id)
  );
  if (!favoriteRecord) return;
  const confirmdelete=window.confirm(
    "Are you sure you want to delete this item from favorires?"
  );
  if (!confirmdelete) return;

  try {
    const response = await fetch(
      FAVORITES_API,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "delete",
          id: favoriteRecord.id   // ✅ backend requires this
        })
      }
    );

    const data = await response.json();
    console.log("DELETE Favorite Response:", data);

    // Remove from UI instantly (no reload)
    const updatedFavorites = favorites.filter(
      f => f.id !== favoriteRecord.id
    );

    setFavorites(updatedFavorites);
    setFavoriteIds(
    updatedFavorites.map(f => String(f.bm_id))
    );
    const updatedIds = updatedFavorites.map(f => String(f.bm_id));
    setFavoriteIds(updatedIds);

  } catch (error) {
    console.error("Delete Favorite Error:", error);
  }
};

const handleproduct = (product) => {
  navigate(`/shopitem?cat_id=${product.cat_id}&bm_id=${product.bm_id}`);
};
  /* ================= CART FUNCTIONS ================= */

  // ❌ item DOES NOT EXIST
  // ❌ replaced by inline dispatch per product

  /*
  function productSelected() {
    const itemInCart = {
      item: item,
      amount: 1,
    };
    dispatch(addItemToCart(itemInCart));
  }

  function increaseItemAmount() {
    const amount = itemAmount + 1;
    dispatch(changeItemAmount({ currentItemId: item.id, currentAmount: amount }));
  }

  function decreaseItemAmount() {
    const amount = itemAmount - 1;
    dispatch(changeItemAmount({ currentItemId: item.id, currentAmount: amount }));
    if (amount === 0) {
      dispatch(deleteItemFromCart(item.id));
    }
  }
  */

  /* ================= RENDER ================= */

  const memoizeedRenderResult = useMemo(() => {
    let filteredProducts = [...productData];
  // No filtering required because submit_favorites.php already returns only favourite brands.
  
if (searchKeyword?.trim()) {

  const keywords = searchKeyword
    .toLowerCase()
    .trim()
    .split(/\s+/);

  filteredProducts = filteredProducts.filter(p => {

    const text = `${p.brand_nm || ""} ${p.cat_name || ""} ${p.shop || ""}`.toLowerCase();

    const textNoSpace = text.replace(/\s+/g, "");

    return keywords.every(k =>
      text.includes(k) || textNoSpace.includes(k)
    );

  });

}

/* 📂 CATEGORY / SHOP FILTER */
if (
  (Array.isArray(selectedShop) && selectedShop.length > 0) ||
  (!Array.isArray(selectedShop) && selectedShop)
) {

  const selectedShopList = Array.isArray(selectedShop)
    ? selectedShop
    : [selectedShop];

  filteredProducts = filteredProducts.filter(product =>
    selectedShopList.some(
      shop =>
        String(shop).trim().toLowerCase() ===
        String(product.shop || "").trim().toLowerCase()
    )
  );
}
/* ================= MULTI SIZE + PRICE FILTER ================= */

const selectedSizes = Array.isArray(mlFilter?.sizes)
  ? mlFilter.sizes
  : [];

const selectedPrices = Array.isArray(mlFilter?.prices)
  ? mlFilter.prices
  : [];

if (
  selectedSizes.length > 0 ||
  selectedPrices.length > 0
) {

  filteredProducts = filteredProducts.filter(product => {

    const sizeOptions = [
      {
        size: `${product.sizeq}ML`,
        price: Number(product.rateq),
        stock: Number(product.stk_q)
      },
      {
        size: `${product.sizep}ML`,
        price: Number(product.ratep),
        stock: Number(product.stk_p)
      },
      {
        size: `${product.sizen}ML`,
        price: Number(product.raten),
        stock: Number(product.stk_n)
      }
    ];

    return sizeOptions.some(option => {

      // ---------- SIZE MATCH ----------

      const sizeMatches =
        selectedSizes.length === 0 ||
        selectedSizes.includes(option.size);


      // ---------- PRICE MATCH ----------

      let priceMatches = true;

      if (selectedPrices.length > 0) {

        priceMatches = selectedPrices.some(range => {

          const price = option.price;

          switch (range) {

            case "0-499":
              return price >= 0 && price <= 499;

            case "500-999":
              return price >= 500 && price <= 999;

            case "1000-1499":
              return price >= 1000 && price <= 1499;

            case "1500-1999":
              return price >= 1500 && price <= 1999;

            case "2000+":
              return price >= 2000;

            default:
              return false;
          }

        });

      }


      // ---------- STOCK MATCH ----------

      const stockMatches = option.stock > 0;


      return (
        sizeMatches &&
        priceMatches &&
        stockMatches
      );

    });

  });

}
    return (
      <>
        {filteredProducts.map(product => {

 const isFav = favoriteIds.includes(String(product.bm_id));

 const selectedSizes = Array.isArray(mlFilter?.sizes)
  ? mlFilter.sizes
  : [];

const productSizes = [
  {
    size: product.sizeq,
    stock: Number(product.stk_q)
  },
  {
    size: product.sizep,
    stock: Number(product.stk_p)
  },
  {
    size: product.sizen,
    stock: Number(product.stk_n)
  }
];

const displayedSizes =
  selectedSizes.length > 0
    ? productSizes
        .filter(option => {
          const size = `${option.size}ML`
            .replace(/\s+/g, "")
            .toUpperCase();

          return (
            selectedSizes.includes(size) &&
            option.stock > 0
          );
        })
        .map(option => `${option.size}ML`)
    : productSizes
        .filter(option => option.stock > 0)
        .map(option => `${option.size}ML`);

const normalize = v => v?.trim().toLowerCase();

const shopInfo = Array.isArray(nearbyShops?.shops)
  ? nearbyShops.shops.find(
      s =>
        String(s.site_id) === String(product.site_id)
    )
  : null;
//const isFav = favorites.includes(product?.id);

const totalAmount = itemsInCart
  .filter(v => v.item.id.startsWith(product.id + "_"))
  .reduce((sum, v) => sum + v.amount, 0);
          // Each product reads ITS OWN cart state
          const cartItem = itemsInCart.find(
            v => v.item.id === product.id
          );

          const amount = cartItem ? cartItem.amount : 0;
          const price = cartItem
            ? cartItem.amount * Number(product.price || 0)
            : 0;

          return (
            <div className="item-card" onClick={() => handleproduct(product)}
  style={{ cursor: "pointer" }} key={product.id}>  

              <div className="item-img-block" style={{ position: "relative" }}>
                 {/* ❤️ FAVORITE ICON */}
  <div
    onClick={(e) => {
      e.stopPropagation();
       if (isFavoritesPage) {
    deleteFavorite(product.bm_id);
  }
      // Later we can add toggle logic here
    }}
    style={{
      position: "absolute",
      top: "8px",
      right: "8px",
      fontSize: "20px",
      cursor: "pointer",
      zIndex: 10
    }}
  >
    {isFav ? "❤️" : ""}
  </div>
    <img
  className="item-img"
  src={`${IMAGE_BASE_URL}${
    product.p_images?.length
        ? product.p_images[0]
        : product.thumb
  }`}
  title={product.brand_nm}
  alt={product.brand_nm}
  onClick={() => setSelectedProduct(product)}
  style={{ cursor: "pointer" }}
/>  <p className="item-description-title" ref={el => {
    if (!el) return;

    let fontSize = 14;
    el.style.fontSize = fontSize + "px";

    while (el.scrollWidth > el.clientWidth && fontSize > 10) {
      fontSize -= 0.5;
      el.style.fontSize = fontSize + "px";
    }
  }}>
      {product.brand_nm}</p>
      </div>{/*
{selectedProduct?.id === product.id && (
  <div className="fullscreen-modal" onClick={() => setSelectedProduct(null)}                                                        >
    <div className="modal-content" onClick={e => e.stopPropagation()} >

      <span
        className="modal-close"
       onClick={() => setSelectedProduct(null)}
      >                                                                                                              
        ✕
      </span>

      <div className="modal-inner">
        <div className="modal-image-block">
          
<div
  className={`fav-icon ${isFav ? "fav-active" : ""}`}
  onClick={(e) => {
    e.stopPropagation();
      if (!isLoggedIn) {
    setLoginMessage(true);
    return;
  }

   toggleFavorite(product.id, product.bm_id);
  }}
>
  {isFav ? "❤️" : "🤍"}
</div>
          <img
            src={`https://gitstool.in/dscsc/shop_app/${selectedProduct.thumb}`}
            alt={selectedProduct.brand_nm}
            className="modal-image"
          />
        </div>

        <div className="modal-info-block">

          <h2 style={{marginTop:"20px"}} > {selectedProduct.brand_nm}</h2>
          
          <p style={{marginTop:"-10px"}}>{selectedProduct.cat_name} • {selectedProduct.shop}</p>
        
          <div className="modal-description">
             
  <span>{product.sizeq}ML</span>
  <span>{product.sizep}ML</span>
  <span>{product.sizen}ML</span>
</div>
          <div className="modal-description">
   
  <span>{product.stk_q}</span>
  <span>{product.stk_p}</span>
  <span>{product.stk_n}</span>
</div>
<div className="modal-description">
   
  <span>₹{product.rateq}</span>
  <span>₹{product.ratep}</span>
  <span>₹{product.raten}</span>
</div>
<h3 style={{marginTop:"20px"}}> Description</h3>
          <p className="desc">{selectedProduct.p_desc} </p>
          Notify Me button 
{["stk_q", "stk_p", "stk_n"].some(key => Number(selectedProduct[key]) === 0) && (
  <div
    className="notify"
    style={{ mcursor: "pointer" }}
    onClick={() => alert(`You'll be notified when ${selectedProduct.brand_nm} is back in stock!`)}
  >
    Notify Me
  </div>
)}          
        </div>
      </div>
    </div>
  </div>
)}*/}

              <div className="item-raiting-block">
                {Number(product.p_rating || 0).toFixed(1)}
              </div>
               <div className="item-name">
                {product.cat_name}
              </div>

              {displayedSizes.length > 0 && (
                <div className="item-size-display">
                  Size: {displayedSizes.join(" • ")}
                </div>
              )}

              {/*<div
                className={
                  totalAmount > 0
                    ? "item-sticker"
                    : "item-sticker_hidden"
                }
              >
                {totalAmount}
              </div>*/}

              <div className="item-description-block">
                {/*<div className="shop-row"><div className="item-controls-par">
                        {product.shop}</div><br></br>
                      <div className="item-controls-par1">
  {shopInfo
    ? `${Number(shopInfo.distance_km).toFixed(2)} km`
    : "Distance unavailable"}
</div>
</div>*/}
                      {/*<p className="shop-add-par">
                        {product.shopAdd}
                      </p><br></br>
                <h2
  className="item-description-title" 
  ref={el => {
    if (!el) return;

    let fontSize = 18;
    el.style.fontSize = fontSize + "px";

    while (el.scrollWidth > el.clientWidth && fontSize > 10) {
      fontSize -= 0.5;
      el.style.fontSize = fontSize + "px";
    }
  }}
>
  {product.brand_nm}
</h2>
<br></br>*/}

               {/*div className="item-description-par">
                  {product.sizeq}ML • {product.sizep}ML • {product.sizen}ML
                </div>
              <div className="item-description-par">
             
  <span>{product.sizeq}ML</span>
  <span>{product.sizep}ML</span>
  <span>{product.sizen}ML</span>
</div>*/}
 {/* <div className="item-description-par">
   
  <span>{product.stk_q}</span>
  <span>{product.stk_p}</span>
  <span>{product.stk_n}</span>
</div>
<div className="item-description-par">
   
  <span>₹{product.rateq}</span>
  <span>₹{product.ratep}</span>
  <span>₹{product.raten}</span>
</div>
<br></br>*/}
             {/* div className="rating-row">
                  <StarRating raiting={Number(product.p_rating || 0)} />
                </div>*/}

        {/* <div className="item-actions"><div className="size-actions">

  {[
    { label: product.sizeq + "ML", key: "Q" },
    { label: product.sizep + "ML", key: "P" },
    { label: product.sizen + "ML", key: "N" }
  ].map(size => {

    const sizeId = `${product.id}_${size.key}`;

    const sizeCartItem = itemsInCart.find(
      v => v.item.id === sizeId
    );

    const sizeAmount = sizeCartItem ? sizeCartItem.amount : 0;
const stock =
  size.key === "Q" ? Number(product.stk_q) :
  size.key === "P" ? Number(product.stk_p) :
  Number(product.stk_n);
 
    return (
      <div
        key={sizeId}
        className={`item-controls-btn ${stock === 0 ? "btn-disabled" : ""}`}
        style={{ flex: 1 }}
      >
        
        {sizeAmount === 0 ? (
          <span
            
    onClick={() => {
       if (stock === 0 ) return;

              dispatch(
                addItemToCart({
                  item: {
                   
                    id: sizeId,
                    bm_id: product.bm_id, 
                    shop: product.shop,
                    shopAdd: product.shopAdd,
                       // ✅ IMPORTANT
    brand_nm: product.brand_nm,
    cat_name: product.cat_name,
    thumb: product.thumb,
    
     selectedRate:
      size.key === "Q" ? product.rateq :
      size.key === "P" ? product.ratep :
      product.raten,
       selectedStock:
      size.key === "Q" ? product.stk_q :
      size.key === "P" ? product.stk_p :
      product.stk_n,
                    selectedSize: size.label
                  },
                  amount: 1
                })
              )
            }}
          >
            {stock === 0 ? "Out of Stock" : "Add +"}
          </span>
        ) : (
          <div className="qty-controls">
            <span
              onClick={e => {
              e.stopPropagation();
                dispatch(
                  changeItemAmount({
                    currentItemId: sizeId,
                    currentAmount: sizeAmount - 1
                  })
                )
              }}
            >
              -
            </span>

            <span className="qty">{sizeAmount}</span>

            <span
              onClick={e => {
              e.stopPropagation();

              if (sizeAmount >= stock) {
                showStockLimit(); // popup
                return;
              }
                dispatch(
                  changeItemAmount({
                    currentItemId: sizeId,
                    currentAmount: sizeAmount + 1
                  })
                )
              }}
            >
              +
            </span>
          </div>
        )}
      </div>
    );
  })}
</div>
</div>*/}
 
              </div>
            </div>
          );
        })}
        
      </>
    );
  }, [
  productData,
  favorites,
  itemsInCart,
  selectedShop,
  selectedShops,
  mlFilter,
  nearbyShops,
  searchKeyword,
  selectedProduct,
  favoriteIds
]);
if (loading && productData.length === 0) {
  return (
    <p style={{ textAlign: "center", color: "white" }}>
      Loading products...
    </p>
  );
}
 return (
  <>
    {memoizeedRenderResult}

    {showLoginMessage && (
      <div
        className="login-warning-overlay"
        onClick={() => setLoginMessage(false)}
      >
        <div
          className="login-warning-box"
          onClick={(e) => e.stopPropagation()}
        >
          <p>Please login to add items in favorites</p>
          <button onClick={() => setLoginMessage(false)}>
            OK
          </button>
        </div>
      </div>
    )}
  </>
);
}

/* ================= PROPTYPES ================= */

// ❗ item prop no longer used
// ❗ kept only because you asked not to remove anything
WineItem.propTypes = {
  item: PropTypes.shape({
    alcohol: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    grapeSort: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    imgBig: PropTypes.string.isRequired,
    imgSmall: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    production: PropTypes.string.isRequired,
    raiting: PropTypes.number.isRequired,
    region: PropTypes.array.isRequired,
    sugar: PropTypes.string.isRequired,
    volume: PropTypes.number.isRequired
  })
};

export default WineItem;